import WINDOW from "../../utils/window";

/**
 * Intersection observer
 * @param {TorusElement} element
 */
const intersections = (element) => {
  /** @type {IntersectionObserverCallback} */
  const callback = (entries) => {
    for (const entry of entries) {
      const node = /** @type {TorusElement} */ (entry.target);
      const container = /** @type {ContainerClassProps} */ (
        node.Torus?.Container
      );

      if (container) {
        for (const target of container.affectedElements) {
          const main = /** @type {MainClassProps} */ (target.Torus?.Main);

          /**
           * Only apply intersection status (visible/hidden) to the elements that are not immediately
           * initialized (class, check, ...)
           */
          if (main && !main.isImmediate) {
            main.isVisible = entry.isIntersecting;
          }
        }
      }
    }
  };

  /** Get global `observers` map */
  const observers = /** @type {WindowObserverProps} */ (
    WINDOW.get("observers")
  );

  /** Set new `IntersectionObserver` to the map */
  observers.set(
    "intersection",
    new IntersectionObserver(callback, { rootMargin: "25%" })
  );

  /** Set type */
  const intersection = /** @type {IntersectionObserver} */ (
    observers.get("intersection")
  );

  intersection.observe(element);
};

export default intersections;
